import { loadDriveApi } from '~app/actions/drive';
import Logging from '~app/core/logging';
import { t } from "~app/AppBundleContext";

const log = Logging.getLogger('app.actions.app');

export const LOADING_STARTED = 'LOADING_STARTED';
export const LOADING_PROGRESS_UPDATE = 'LOADING_PROGRESS_UPDATE';
export const LOADING_FINISHED = 'LOADING_FINISHED';
export const CREATE_MESSAGE = 'CREATE_MESSAGE';
export const CLEAR_MESSAGES = 'CLEAR_MESSAGES';
export const SET_APP_VERSION = 'SET_APP_VERSION';

export function load() {
  return async (dispatch, getState) => {
    dispatch(startLoading(t("loading-google"), null));
    try {
      await dispatch(loadDriveApi(() => updateLoadingProgress(t("loading-google"))));
    }
    catch(error) {
      const message = t("failed-load-google");
      const subMessage = t("no-save-load-google");
      dispatch(createMessage(message, "danger", subMessage));
    }

    dispatch(finishLoading(), null);
  };
}

export function startLoading(message, percentComplete = null) {
  log.info('loading started');
  return {
    type: LOADING_STARTED,
    message,
    progressPct: percentComplete,
  };
}

export function updateLoadingProgress(message, percentComplete = undefined) {
  return {
    type: LOADING_PROGRESS_UPDATE,
    message,
    progressPct: percentComplete,
  };
}

export function finishLoading() {
  log.info('loading finished');
  return {
    type: LOADING_FINISHED,
  };
}

export function createMessage(message, type, subMessage) {
  return {
    type: CREATE_MESSAGE,
    payload: {
      message,
      subMessage,
      type,
    },
  };
}

export function clearMessages() {
  return {
    type: CLEAR_MESSAGES,
  };
}

export function setAppVersion(version) {
  return {
    type: SET_APP_VERSION,
    version,
  };
}


// WEBPACK FOOTER //
// ./src/actions/app.js